import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import Header from "../components/Header"

const Imprint: React.FC = () => {
	const navigate = useNavigate()

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<>
			<Header />
			<div className="container mx-auto max-w-[800px] py-8 px-4 text-red">
				<h2 className="h2 mt-12 text-2xl font-bold text-red">Impressum</h2>
				<h2 className="mt-8 mb-2 text-[20px] font-bold leading-tight">Wilkinson Sword GmbH </h2>
				<p className=" mb-4">
					Schützenstraße 110
					<br />
					42659 Solingen
					<br />
					Germany
				</p>
				<p className=" mb-4">
					Telefon: +49 212 405 0 (Mo-Fr: 09-15 Uhr)
					<br />
					E-Mail: <a href="mailto:Help@Wilkinsonsword.com">Help@Wilkinsonsword.com</a>
					<br />
				</p>
				<p className=" mb-4">
					Geschäftsführer: <br />
					Thomas Lummerich, Jochen Schmitz, John Norman Hill, LaTanya Langley
				</p>
				<p className=" mb-4">
					Handelsregister: HRB 16753 Registergericht: Amtsgericht Wuppertal
					<br />
					Ust-ID gemäß §27a Umsatzsteuergesetz: DE813978227
				</p>
			</div>
			<div className="bg-beige py-10 pt-5 text-center text-xl text-red">
				<button onClick={() => navigate(-1)} className="btn btn-hero mt-8 rounded bg-red px-12 py-4 text-white">
					Zurück
				</button>
			</div>
		</>
	)
}
export default Imprint
